import * as React from 'react';

import { UIHeading5 } from '@cian/ui-kit';
import { IconActionArrowLeft24 } from '@cian/ui-kit-design-tokens/icons';
import * as style from './styles.css';

export interface IHeaderProps {
  onClose: () => void;
}

export const Header = ({ onClose }: IHeaderProps): React.JSX.Element => {
  return (
    <div className={style['header-container']}>
      <div className={style['icon-wrapper']} data-testid="ai-summary-mobile-back" onClick={onClose}>
        <IconActionArrowLeft24 color="icon-main-default" />
      </div>
      <UIHeading5>Итоги сравнения от ИИ</UIHeading5>
      <div className={style['icon-wrapper']} />
    </div>
  );
};
